<template>
  <div class="no_nav_height">
    <div class="row f-row mb-2">
      <div
        class="markets-chart-title col col-12"
        style="text-align: center!important;"
      >
        Analysis:
        <span style="color: var(--textactive); font-size: 1.1rem">
          {{ Analytics["userSelections"]["selectionStr"] }}</span
        >
      </div>
    </div>
    <!-- filter div -->
    <div class="filters-front-div" v-if="showFilters">
      <CommodityFilters
        :dataFilters="Analytics['rawData']['dataFilters']"
        :dataVar="Analytics['rawData']['mergedExpoHedges']"
        :dDowns="Analytics['rawData'].dDowns"
        :showLoading="loadingAll"
        @eventOnFilteredData="onFilteredData"
        @eventOnUserFilter="onUserFilter"
        @eventOnUserShowFilters="onUserShowFilters"
      />
    </div>
    <!-- Company/Portfolio/Asset Selection -->
    <div class="row f-row mt-2 mb-2">
      <div class="col col-12">
        <CompanyPortProdSelector
          :Analytics="Analytics"
          :companies="Analytics['companies']"
          :colorTheme="colorTheme"
          :fixing_type="fixing_type"
          :loadingAll="loadingAll"
          :companyParametersReady="companyParametersReady"
          :renderFilters="true"
          :showFilters="showFilters"
          :screenWidth="screenWidth"
          @eventOnMktRefChange="onMktRefChange"
          @eventOnUserCompany="onUserCompany"
          @eventOnUserPortfolio="onUserPortfolio"
          @eventOnUserFetchData="onUserFetchData"
          @eventOnUserAsset="onUserAsset"
          @eventOnUserShowFilters="onUserShowFilters"
          @eventOnUserSpotChange="onUserSpotChange"
          @eventOnUserFetchExpand="onUserFetchExpand"
          @eventOnUserShow="onUserShow"
          @eventOnUserZoom="onUserZoom"
          @eventOnUserYear="onUserYear"
          @eventOnUserRestoreSizes="onRestoreSizes"
        />
      </div>
    </div>

    <!-- Charts -->
    <div class="row f-row container_no_selectors_height">
      <Splitter
        class="col"
        layout="vertical"
        v-bind:class="[
          Analytics['userSelections'].expandSidebar ? 'col-9' : 'col-12',
        ]"
        @onContext="onContext"
      >
        <!-- Chart container 1 -->
        <SplitterPanel
          class="row f-row prices_height"
          :size="chartSizes.sizeSplitterChartPrices"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterChartPrices};`"
        >
          <div class="col col-12 no_selectors_height">
            <div class="row f-row">
              <div class="chart-title-results text-left d-flex bdr-b">
                {{
                  Analytics["userSelections"].bucket.charAt(0) +
                    Analytics["userSelections"].bucket
                      .substring(1)
                      .toLowerCase()
                }}
                {{
                  Analytics["assetType"] === "commodity" ? "prices" : "rates"
                }}&nbsp;
                <span style="color: var(--textactive)">
                  ({{
                    Analytics["assetType"] === "commodity"
                      ? Analytics["userSelections"]["includeFutures"] &&
                        !Analytics["userSelections"]["includeBasis"] &&
                        !Analytics["userSelections"]["includeRatio"]
                        ? (Analytics["userSelections"]["selectedUnderlying"][0][
                            "is_cents"
                          ]
                            ? "USc"
                            : Analytics["userSelections"][
                                "selectedUnderlying"
                              ][0]["fk_idcurrency"]) +
                          "/" +
                          Analytics["userSelections"]["selectedUnderlying"][0][
                            "fk_idunit"
                          ]
                        : Analytics["userSelections"]["selectedAsset"][0][
                            "fk_idcurrency"
                          ] +
                          "/" +
                          Analytics["userSelections"]["selectedAsset"][0][
                            "fk_idunit"
                          ]
                      : Analytics["userSelections"]["selectedAsset"][0][
                          "currency_name"
                        ]
                  }})</span
                >
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Spinner 1 -->
            <div
              class="col col-12 text-center"
              v-if="loadingAll || Analytics['loading']['topographyCalcs']"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="
                  loadingAll || Analytics['loading']['topographyCalcs']
                "
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <!-- No Data Available available 1 -->
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <!--  Container chart 1 -->
            <div class="row f-row container_chart_prices" v-else>
              <!-- Chart 1 -->
              <div class="col col-1 h-100 mt-3">
                <RatesChartSelectors
                  :asset="'currencies'"
                  :fwdName="'Market'"
                  :isAdvanced="false"
                  :isHorizontal="false"
                  :lCall="
                    Analytics['userSelections']['showLCall']
                      ? Analytics['images']['lCall']
                      : Analytics['images']['lCallOff']
                  "
                  :lFwd="
                    Analytics['userSelections']['showLFwd']
                      ? Analytics['images']['lFwd']
                      : Analytics['images']['lFwdOff']
                  "
                  :lPut="
                    Analytics['userSelections']['showLPut']
                      ? Analytics['images']['lPut']
                      : Analytics['images']['lPutOff']
                  "
                  :sCall="
                    Analytics['userSelections']['showSCall']
                      ? Analytics['images']['sCall']
                      : Analytics['images']['sCallOff']
                  "
                  :sFwd="
                    Analytics['userSelections']['showSFwd']
                      ? Analytics['images']['sFwd']
                      : Analytics['images']['sFwdOff']
                  "
                  :showAve="Analytics['userSelections']['showAve']"
                  :showBasisRatio="Analytics['userSelections']['showCommited']"
                  :showBudget="Analytics['userSelections']['showBudget']"
                  :showDerivatives="Analytics['userSelections']['showAll']"
                  :showExpo="Analytics['userSelections']['showForecast']"
                  :showFixedHedged="
                    Analytics['userSelections']['showFixedHedged']
                  "
                  :showHedge="Analytics['userSelections']['showFixedFutures']"
                  :showLCall="Analytics['userSelections']['showLCall']"
                  :showLFwd="Analytics['userSelections']['showLFwd']"
                  :showLPut="Analytics['userSelections']['showLPut']"
                  :showMkt="Analytics['userSelections']['showMarket']"
                  :showNet="Analytics['userSelections']['showNet']"
                  :showOHLC="false"
                  :showProtected="
                    Analytics['userSelections']['showHedgedFutures']
                  "
                  :showSCall="Analytics['userSelections']['showSCall']"
                  :showSFwd="Analytics['userSelections']['showSFwd']"
                  :showSPut="Analytics['userSelections']['showSPut']"
                  :sPut="
                    Analytics['userSelections']['showSPut']
                      ? Analytics['images']['sPut']
                      : Analytics['images']['sPutOff']
                  "
                  @eventOnShow="onUserShow"
                  @eventOnShowDerivatives="onUserShow(13)"
                />
              </div>
              <div class="col col-11 h-100">
                <RatesChart
                  :asset="'currencies'"
                  :averages="[]"
                  :budgetRate="null"
                  :candleData="[]"
                  :chartData="Analytics['rawData']['zoomedData']"
                  :colorTheme="colorTheme"
                  :controlsSpace="false"
                  :createAnalyticsVars="Analytics['createAnalyticsVars']"
                  :currency="assetUnits"
                  :dateFormat="'%b %y'"
                  :derivativeAverages="[]"
                  :derivativeDateField="'hedged_date'"
                  :hedgeData="Analytics['rawData']['zoomedData']"
                  :historicalData="[]"
                  :isAdvanced="false"
                  :includeFutures="
                    Analytics['userSelections']['includeFutures']
                  "
                  :includeBasis="Analytics['userSelections']['includeBasis']"
                  :includeRatio="Analytics['userSelections']['includeRatio']"
                  :includeOtherCosts="
                    Analytics['userSelections']['includeOtherCosts']
                  "
                  :isFuture="true"
                  :minMaxYAxis="[0, 5500]"
                  :pickedBucket="'1M'"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  :showAve="Analytics['userSelections']['showAve']"
                  :showCommited="Analytics['userSelections']['showCommited']"
                  :showBudget="Analytics['userSelections']['showBudget']"
                  :showExpo="Analytics['userSelections']['showForecast']"
                  :showFixedHedged="
                    Analytics['userSelections']['showFixedHedged']
                  "
                  :showHedge="Analytics['userSelections']['showFixedFutures']"
                  :showLCall="Analytics['userSelections']['showLCall']"
                  :showLFwd="Analytics['userSelections']['showLFwd']"
                  :showLoading="
                    Analytics['loading']['topographyCalcs'] ||
                      Analytics['loading']['topographyCalcsRates'] ||
                      Analytics['loading']['portCalcs']
                  "
                  :showLPut="Analytics['userSelections']['showLPut']"
                  :showMkt="Analytics['userSelections']['showMarket']"
                  :showNet="Analytics['userSelections']['showNet']"
                  :showProtected="
                    Analytics['userSelections']['showHedgedFutures']
                  "
                  :showSCall="Analytics['userSelections']['showSCall']"
                  :showSFwd="Analytics['userSelections']['showSFwd']"
                  :showSimulations="false"
                  :showSPut="Analytics['userSelections']['showSPut']"
                  :showTooltip="false"
                  :showTooltipDeriv="true"
                  :simulations="[]"
                  :xRange="Analytics['rawData']['expo'].map((d) => d.date)"
                  :zeroRequests="true"
                  :isZoomY="true"
                  @onTableFormat="onTableFormat"
                />
              </div>
            </div>
          </div>
        </SplitterPanel>
        <SplitterGutter
          :index="0"
          :_this="context"
          @resizestart="onResizePanel"
          @onResize="onResizePanel"
          @resizeend="onResizePanel"
        ></SplitterGutter>
        <!-- Chart container 2 -->
        <SplitterPanel
          class="row f-row"
          :class="classChartQty"
          :size="chartSizes.sizeSplitterChart"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterChart}%`"
        >
          <div class="col col-12 quantity_chart_height">
            <div class="row f-row">
              <div
                class="chart-title-results text-left d-flex bdr-b"
                style="line-height: 9px!important;"
              >
                <span class="inh mr-2">
                  <label
                    :for="'normQty'"
                    class="toggle__button_g"
                    style="height: 100%"
                    :class="{
                      actives: normalizeQty,
                    }"
                  >
                    <input
                      type="checkbox"
                      v-on:click="onUserNormalizeQty"
                      :id="'normQty'"
                    />
                    <span class="toggle__switch_g"></span>
                  </label>
                </span>
                <span style="padding-top: 4px; padding-right: 5px;">
                  {{
                    Analytics["assetType"] === "commodity"
                      ? "Quantities"
                      : "Notional"
                  }}
                  <span style="color: var(--textactive);">
                    ({{
                      !normalizeQty
                        ? Analytics["assetType"] === "commodity"
                          ? assetUnits["base"]
                          : assetUnits["foreign"]
                        : "%"
                    }})</span
                  >
                </span>
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Spinner 2 -->
            <div
              class="col col-12 text-center"
              v-if="loadingAll"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="loadingAll"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <!-- No Data Available available 2 -->
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <!--  Chart 2 -->
            <div class="row f-row container_chart_quantity" v-else>
              <div class="col col-1 mt-3 container-chart_chart_quantity">
                <PlanningSelectors
                  :asset="'currencies'"
                  :executeVolatility="true"
                  :expandFRow="true"
                  :isAdvanced="false"
                  :isHorizontal="false"
                  :normalizePlanning="normalizeQty"
                  :selectedExecutionTime="'month'"
                  :showBasisRatio="Analytics['userSelections']['showCommited']"
                  :showBudget="Analytics['userSelections']['showBudget']"
                  :showDates="false"
                  :showExpo="Analytics['userSelections']['showForecast']"
                  :showFixedHedged="
                    Analytics['userSelections']['showFixedHedged']
                  "
                  :showHedge="Analytics['userSelections']['showFixedFutures']"
                  :showProtected="
                    Analytics['userSelections']['showHedgedFutures']
                  "
                  :showProgram="Analytics['userSelections']['showProgram']"
                  :showRequired="false"
                  :xRange="Analytics['rawData']['expo'].map((d) => d.date)"
                  :zoomFinal="0"
                  :zoomInitial="12"
                  @eventOnShow="onUserShow"
                  @eventOnShowProgram="onUserShow(14)"
                />
              </div>
              <div class="col col-11 h-100 container-chart_chart_quantity">
                <!-- Row: Chart -->
                <PlanningChart
                  :asset="'currencies'"
                  :averages="[]"
                  :budgetRate="null"
                  :chartData="Analytics['rawData']['zoomedData']"
                  :colorTheme="colorTheme"
                  :currency="assetUnits"
                  :dateFormat="'%b %y'"
                  :expandFRow="false"
                  :isAdvanced="false"
                  :isFuture="true"
                  :normalizePlanning="normalizeQty"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  :showBudget="Analytics['userSelections']['showBudget']"
                  :showBasisRatio="Analytics['userSelections']['showCommited']"
                  :showExpo="Analytics['userSelections']['showForecast']"
                  :showHedge="Analytics['userSelections']['showFixedFutures']"
                  :showFixedHedged="
                    Analytics['userSelections']['showFixedHedged']
                  "
                  :showProtected="
                    Analytics['userSelections']['showHedgedFutures'] ||
                      !this.Analytics['userSelections']['showFixedHedged']
                  "
                  :showLoading="
                    Analytics['loading']['topographyCalcs'] ||
                      Analytics['loading']['topographyCalcsRates'] ||
                      Analytics['loading']['portCalcs']
                  "
                  :showProgram="Analytics['userSelections']['showProgram']"
                  :showRequired="false"
                  :showTooltip="false"
                  :zeroRequests="true"
                  @onTableFormat="onTableFormat"
                />
              </div>
            </div>
          </div>
        </SplitterPanel>
        <SplitterGutter
          :index="isUserSelectionActive ? 1 : 0"
          :_this="context"
          @resizestart="onResizePanel"
          @onResize="onResizePanel"
          @resizeend="onResizePanel"
          :eventElement="newEventElement"
          :eventParentElement="eventParentElement"
        ></SplitterGutter>
        <!-- Table container 3 -->
        <SplitterPanel
          class="row f-row table_height"
          :size="chartSizes.sizeSplitterTable"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterTable}%`"
        >
          <div class="col col-12 container_table">
            <div class="row f-row">
              <div
                class="chart-title-results text-left d-flex bdr-b"
                style="line-height: 9px!important;"
              >
                <span class="inh mr-2" v-if="!isCurrency">
                  <label
                    :for="'detailsAll'"
                    class="toggle__button_g"
                    style="height: 100%"
                    :class="{
                      actives: Analytics['userSelections']['showDetails'],
                    }"
                  >
                    <input
                      type="checkbox"
                      v-on:click="onUserShowDetails"
                      :id="'detailsAll'"
                    />
                    <span class="toggle__switch_g"></span>
                  </label>
                </span>
                <span style="padding-top: 4px; padding-right: 5px;"
                  >Consolidated data</span
                >
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col col-12 text-center"
              v-if="loadingAll"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="loadingAll"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <template v-else>
              <CommodityAdvancedTable
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :divName="'scenarios'"
                :formatVar="formatVar.userHovered"
                :isAdvanced="false"
                :isLarge="true"
                :isPast="true"
                :isTotals="false"
                :loadingAll="loadingAll"
                :noDataStr="noDataStr"
                :renderChartSignal="renderChartSignal"
                :showDetails="true"
                :sUnit="
                  Analytics['assetType'] === 'commodity'
                    ? Analytics['userSelections']['selectedAsset'][0][
                        'fk_idunit'
                      ]
                    : Analytics['userSelections']['selectedAsset'][
                        'fk_idcurrency_right'
                      ]
                "
                :tableFormat="infoTable"
                :unit="
                  Analytics['assetType'] === 'commodity'
                    ? Analytics['userSelections']['selectedAsset'][0][
                        'fk_idcurrency'
                      ]
                    : Analytics['userSelections']['selectedAsset'][
                        'fk_idcurrency_left'
                      ]
                "
                :zoomedData="Analytics['rawData']['zoomedData']"
              />
            </template>
          </div>
        </SplitterPanel>
      </Splitter>
      <!-- Totals -->
      <div
        v-if="Analytics['userSelections'].expandSidebar"
        class="col col-3 no_selectors_height results-divider"
      >
        <div class="row f-row">
          <div class="chart-title-results text-left d-flex bdr-b">
            Aggregates
            <div class="ml-auto sidebarHidden">
              <button
                @click="onClientExpandSidebar"
                class="btn mr-1"
                style="width: 12px;"
              >
                <i
                  class="fa fa-arrow-left"
                  v-if="!Analytics['userSelections'].expandSidebar"
                ></i>
                <i
                  class="fa fa-arrow-right"
                  v-if="Analytics['userSelections'].expandSidebar"
                ></i>
              </button>
            </div>
          </div>
        </div>
        <CommodityAdvancedTable
          :Analytics="Analytics"
          :colorTheme="colorTheme"
          :divName="'scenarios'"
          :formatVar="formatVar.userHovered"
          :isAdvanced="false"
          :isLarge="false"
          :isPast="true"
          :isTotals="true"
          :loadingAll="loadingAll"
          :noDataStr="noDataStr"
          :renderChartSignal="renderChartSignal"
          :showDetails="true"
          :sUnit="
            Analytics['assetType'] === 'commodity'
              ? Analytics['userSelections']['selectedAsset'][0]['fk_idunit']
              : Analytics['userSelections']['selectedAsset'][
                  'fk_idcurrency_right'
                ]
          "
          :tableFormat="infoTable"
          :unit="
            Analytics['assetType'] === 'commodity'
              ? Analytics['userSelections']['selectedAsset'][0]['fk_idcurrency']
              : Analytics['userSelections']['selectedAsset'][
                  'fk_idcurrency_left'
                ]
          "
          :zoomedData="Analytics['rawData']['totals']"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  // bucketNames,
  colorDarkExpo,
  colorDarkExpoAlpha3,
  colorExpoAlpha4,
  colorFwd,
  colorFwdAlpha2,
  colorHedge,
  colorHedgeAlpha,
  colorNet,
  colorNetAlpha2,
  colorNet_2,
  colorNet_2Alpha_2,
  colorProgram,
  colorProgramAlpha,
  colorSymmetry,
  currencyFormat3,
  formatM,
  darkBackgroundAlpha,
  whiteGray,
  whiteGrayAlpha3,
} from "@/_core/_helpers/_parametric_tools";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import { select } from "d3";
import {
  infoLegends,
  translateOnShow,
} from "@/_core/data/Analytics/AnalyticsGeneral.js";
import CommodityAdvancedTable from "@/components/advanced/CommodityAdvancedTable.vue";
import CommodityFilters from "@/components/analytics/CommodityFilters";
import CompanyPortProdSelector from "./CompanyPortProdSelector";
import PlanningChart from "@/components/advanced/PlanningChart.vue";
import PlanningSelectors from "@/components/advanced/PlanningSelectors.vue";
import QSLoading from "@/components/QSLoading.vue";
import RatesChart from "@/components/advanced/RatesChart.vue";
import RatesChartSelectors from "@/components/advanced/RatesChartSelectors.vue";
import Splitter from "../splitter/Splitter.vue";
import SplitterGutter from "../splitter/SplitterGutter.vue";
import SplitterPanel from "../splitter/SplitterPanel.vue";

export default {
  name: "VisualizationChartsTable",
  components: {
    CommodityAdvancedTable,
    CommodityFilters,
    CompanyPortProdSelector,
    Splitter,
    SplitterPanel,
    SplitterGutter,
    QSLoading,
    RatesChart,
    RatesChartSelectors,
    PlanningChart,
    PlanningSelectors,
  },
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics(),
    },
    colorTheme: { required: true, type: Boolean, default: true },
    companyParametersReady: { required: true, type: Boolean, default: false },
    isCurrency: { required: false, type: Boolean, default: true },
    fixing_type: { required: false, type: String, default: "ratio" },
    processData: { required: true },
    screenWidth: { required: false, type: Number, default: 1280 },
    eventElement: { required: false, default: () => PointerEvent },
  },
  data() {
    return {
      chartSizes: {
        sizeSplitterChartPrices: 42,
        sizeSplitterChart: 19.8,
        sizeSplitterTable: 38.2,
      },
      context: {},
      eventParentElement: null,
      formatVar: {
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
      },
      formatVars: [],
      infoLegends: [],
      infoTable: [],
      newEventElement: PointerEvent,
      onChangeScenarios: false,
      panels: [],
      showFilters: false,
      translateOnShow: {},
    };
  },
  watch: {
    "Analytics.userSelections.showDetails"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showBudget"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showForecast"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showCommited"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showFixedFutures"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showHedgedFutures"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showProgram"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showMarket"() {
      this.infoTableFct();
    },
    "Analytics.userSelections.showNet"() {
      this.infoTableFct();
    },
    colorTheme() {
      this.infoTableFct();
    },
    eventElement(newEvent) {
      const containerChartQty = select(".quantity-xl_height");
      const parentNode =
        containerChartQty.node() && containerChartQty.node().nextSibling;

      this.newEventElement = newEvent;
      this.eventParentElement = parentNode;
      this.onChangeScenarios = true;
    },
    chartSizes: {
      handler: "handleSplitterSizeChange",
      deep: true,
    },
    classChartQty(newVal) {
      if (newVal === "quantity_height") {
        this.chartSizes.sizeSplitterChartPrices = 42;
        this.chartSizes.sizeSplitterChart = 19.8;
        this.chartSizes.sizeSplitterTable = 38.2;
      } else {
        this.chartSizes.sizeSplitterChart = 61.8;
        this.chartSizes.sizeSplitterTable = 38.2;
      }
    },
    renderChartSignal() {
      this.infoTableFct();
    },
  },
  computed: {
    assetUnits() {
      if (this.isCurrency) {
        const currencyName =
          this.Analytics &&
          this.Analytics.userSelections &&
          this.Analytics.userSelections.selectedAsset &&
          this.Analytics.userSelections.selectedAsset[0] &&
          this.Analytics.userSelections.selectedAsset[0].currency_name;
        if (!currencyName || typeof currencyName !== "string") {
          return {
            foreign: "-",
            rate: "-",
            base: "-",
          };
        }
        return {
          foreign: currencyName.slice(0, 3),
          rate: currencyName.slice(0, 3) + "/" + currencyName.slice(3, 6),
          base: currencyName.slice(3, 6),
        };
      } else {
        const commodityName =
          this.Analytics &&
          this.Analytics.userSelections &&
          this.Analytics.userSelections.selectedAsset &&
          this.Analytics.userSelections.selectedAsset[0] &&
          this.Analytics.userSelections.selectedAsset[0].product_name;
        if (!commodityName || typeof commodityName !== "string") {
          return {
            foreign: "-",
            rate: "-",
            base: "-",
          };
        }
        const cmdty = this.Analytics.userSelections.selectedAsset[0];
        return {
          foreign: cmdty.fk_idcurrency,
          rate: cmdty.fk_idcurrency + "/" + cmdty.fk_idunit,
          base: cmdty.fk_idunit,
        };
      }
    },
    normalizeQty() {
      return this.Analytics["userSelections"].normalizeQty;
    },
    noDataStr() {
      return this.Analytics["rawData"]["toBeFetched"]
        ? "Get Information"
        : "No Data Available";
    },
    loadingAll() {
      const loading = this.Analytics["loading"];
      return (
        loading["derivatives"] ||
        loading["expoFuture"] ||
        loading["expoPast"] ||
        loading["hedgesFuture"] ||
        loading["hedgesPast"] ||
        loading["strategies"]
      );
    },
    renderChartSignal() {
      return this.Analytics["rawData"]["render"];
    },
    AnalyticsUserSelections() {
      return this.Analytics["userSelections"];
    },
    isUserSelectionActiveScenarios() {
      const userSelectionAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];
      return (
        userSelectionAnalysis === "scenario" ||
        userSelectionAnalysis === "scenarios"
      );
    },
    isUserSelectionActive() {
      return (
        this.isUserSelectionActiveScenarios ||
        this.Analytics["userSelections"]["selectedAnalysis"] ===
          "derivatives" ||
        this.Analytics["userSelections"]["selectedAnalysis"] === "strategies"
      );
    },
    classChartQty() {
      const analysis = this.Analytics.userSelections.selectedAnalysis;
      if (
        ["scenario", "scenarios", "derivatives", "strategies"].includes(
          analysis,
        )
      ) {
        return "quantity_height";
      }
      return "quantity-xl_height";
    },
    dynamicChartQty() {
      const selectedAnalysis = this.Analytics.userSelections.selectedAnalysis;

      if (selectedAnalysis === "strategies") return "CommodityQtyStrategies";
      if (selectedAnalysis === "derivatives") return "CommodityQDerivatives";
      if (selectedAnalysis === "clients") return "CommodityClients";
      if (selectedAnalysis === "providers") return "CommodityProviders";
      if (selectedAnalysis === "counterparty") return "CommodityCounterparty";
      if (this.isUserSelectionActiveScenarios) return "CommodityQty";

      return null; // fallback
    },
    dynamicTable() {
      const selectedAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];

      if (selectedAnalysis === "strategies") {
        return "CommodityStrategyTable";
      } else {
        return "CommodityTable";
      }
    },
  },
  created() {
    this.createFormatVars();
    this.infoLegends = infoLegends;
    this.translateOnShow = translateOnShow;
  },
  mounted() {
    this.infoTableFct();
    if (!this.isCurrency) {
      Object.assign(this.Analytics["userSelections"], {
        showDetails: false,
        showProgram: false,
      });
    }
  },
  methods: {
    changeInfoTable(val) {
      this.infoTable = val;
    },
    handleSplitterSizeChange() {
      this.$emit("resizeCharts");
    },
    onResizePanel(value) {
      this.panels = value.panels;
      if (this.onChangeScenarios) {
        this.sizeSplitters({ isRestore: true });
      } else {
        this.sizeSplitters({});
      }
      this.onChangeScenarios = false;
    },
    onTableFormat(val) {
      Object.assign(this.formatVar, {
        userHovered: {
          date: val.date,
          variable: val.variable,
          hovered: val.hovered,
          fromChart: val.fromChart,
        },
      });
    },
    onContext(context) {
      this.context = context;
    },
    onRestoreSizes() {
      this.sizeSplitters({ isRestore: true });
    },
    sizeSplitters({ isRestore = false }) {
      this.panels.forEach((panel) => {
        const el = panel.$el.className;
        const selectElement = select(`.${el.split(" ").join(".")}`);
        if (isRestore) {
          selectElement
            .style("height", `${panel.size}%`)
            .style(
              "flex-basis",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`,
            );
        }
      });
      this.$emit("resizeCharts");
    },
    // ==== emits
    onMktRefChange(val) {
      this.$emit("eventOnMktRefChange", val);
    },
    onClientExpandSidebar() {
      let bool = !this.Analytics["userSelections"].expandSidebar;
      this.$emit("eventOnClientExpandSidebar", bool);
    },
    onUserAsset(newValue) {
      this.$emit("eventOnUserAsset", newValue);
    },
    onUserCompany(newValue) {
      this.$emit("eventOnUserCompany", newValue);
    },
    onUserFetchData() {
      this.$emit("eventOnUserFetchData");
    },
    onUserSpotChange(val) {
      this.$emit("eventOnUserSpotChange", val);
    },
    onUserPortfolio(newValue) {
      this.$emit("eventOnUserPortfolio", newValue);
    },
    onUserShowFilters(val) {
      this.showFilters = val;
    },
    onUserFetchExpand() {
      this.$emit("eventOnUserFetchExpand");
    },
    onFilteredData(data) {
      this.$emit("eventOnFilteredData", data);
    },
    onUserFilter(fltr) {
      this.$emit("eventOnUserFilter", fltr);
    },
    onUserShow(str) {
      this.$emit("eventOnUserShow", this.translateOnShow[str]);
    },
    onUserZoom(num) {
      this.$emit("eventOnUserZoom", num);
    },
    onUserNormalizeQty() {
      this.$emit("eventOnUserNormalizeQty");
    },
    onUserShowDetails() {
      this.$emit("eventOnUserShowDetails");
    },
    onUserYear(yearNum) {
      this.$emit("eventOnUserYear", yearNum);
    },
    infoTableFct() {
      // function hasNonNaNValue(arr, key) {
      //   return (arr || []).some(
      //     (obj) => obj && obj[key] != null && !Number.isNaN(Number(obj[key])),
      //   );
      // }
      let infoT = [];
      // Price
      if (this.Analytics["userSelections"]["showMarket"]) {
        infoT.push(this.market("p"));
      }
      if (this.Analytics["userSelections"]["showForecast"]) {
        infoT.push(this.forecast("p"));
      }
      if (this.Analytics["userSelections"]["showCommited"]) {
        infoT.push(this.commited("p"));
      }
      if (this.Analytics["userSelections"]["showFixedFutures"]) {
        infoT.push(this.fixed("p"));
      }
      if (this.Analytics["userSelections"]["showHedgedFutures"]) {
        infoT.push(this.options("p"));
      }
      if (this.Analytics["userSelections"]["showNet"]) {
        infoT.push(this.net("p"));
      }
      // // Derivatives
      // const data = this.Analytics["rawData"]["nestedData"];
      // if (this.Analytics["userSelections"]["showAll"]) {
      //   if (hasNonNaNValue(data, "lFwd")) {
      //     infoT.push(this.lFwdFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "sFwd")) {
      //     infoT.push(this.sFwdFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "lCall")) {
      //     infoT.push(this.lCallFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "lCallKO")) {
      //     infoT.push(this.lCallKOFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "sCall")) {
      //     infoT.push(this.sCallFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "sCallKO")) {
      //     infoT.push(this.sCallKOFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "lPut")) {
      //     infoT.push(this.lPutFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "lPutKO")) {
      //     infoT.push(this.lPutKOFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "sPut")) {
      //     infoT.push(this.sPutFct("p"));
      //   }
      //   if (hasNonNaNValue(data, "sPutKO")) {
      //     infoT.push(this.sPutKOFct("p"));
      //   }
      // }
      // Qty
      if (
        this.Analytics["userSelections"]["showBudget"] &&
        this.Analytics["userSelections"]["showDetails"]
      ) {
        infoT.push(this.budget("q"));
      }
      if (this.Analytics["userSelections"]["showForecast"]) {
        infoT.push(this.forecast("q"));
      }
      if (this.Analytics["userSelections"]["showCommited"]) {
        infoT.push(this.commited("q"));
      }
      if (this.Analytics["userSelections"]["showFixedFutures"]) {
        infoT.push(this.fixed("q"));
      }
      if (this.Analytics["userSelections"]["showHedgedFutures"]) {
        infoT.push(this.options("q"));
      }
      if (this.Analytics["userSelections"]["showProgram"]) {
        infoT.push(this.programFct("q"));
      }
      // Difference
      infoT.push(this.difference("p"));
      infoT.push(this.differenceThree("p"));
      if (!this.isCurrency && this.Analytics["userSelections"]["showDetails"]) {
        infoT.push(this.differenceTwo("p"));
      }
      if (this.Analytics["userSelections"]["showDetails"]) {
        infoT.push(this.differenceOne("p"));
      }

      Object.assign(this, { infoTable: infoT });
    },
    createFormatVars() {
      this.formatVars = {
        budgetBColor: colorDarkExpoAlpha3,
        budgetColor: colorDarkExpo,
        differenceBColor: darkBackgroundAlpha,
        forecastBColor: colorExpoAlpha4,
        forecastColor: colorSymmetry,
        fixBColor: colorFwdAlpha2,
        fixColor: colorFwd,
        hedgedBColor: colorNet_2Alpha_2,
        hedgedColor: colorNet_2,
        mktBColor: whiteGrayAlpha3,
        mktColor: whiteGray,
        netBColor: colorNetAlpha2,
        netColor: colorNet,
        programBColor: colorProgramAlpha,
        programColor: colorProgram,
        ratioBColor: colorHedgeAlpha,
        ratioColor: colorHedge,
      };
    },
    budget(pOrQ) {
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["budgetBColor"](this.colorTheme),
        colorBdr: this.formatVars["budgetColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "p_budget" : "q_budget",
        elementNameTable: pOrQ === "p" ? "" : "PLANBudg",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Budget",
        nameData: pOrQ === "p" ? "p_budget" : "q_budget",
        sUnit: this.assetUnits["base"],
        unit: this.assetUnits["foreign"],
        unitPerc: pOrQ === "p" ? "budgetPPerc" : "q_budgetPerc",
      });
    },
    forecast(pOrQ) {
      const elementName =
        pOrQ === "p" ? (this.isCurrency ? "p_budget" : "budget") : "q_forecast";
      return this.getConfig({
        addLabel: false,
        colorBckTable: this.formatVars["forecastBColor"](this.colorTheme),
        colorBdr: this.formatVars["forecastColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: elementName,
        elementNameTable: pOrQ === "p" ? "RATEB" : "PLANCF",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: pOrQ === "p" ? "Reforecast" : "Reforecast",
        nameData: elementName,
        sUnit: this.assetUnits["base"],
        unit: this.assetUnits["foreign"],
        unitPerc: "-",
      });
    },
    commited(pOrQ) {
      const elementName =
        pOrQ === "p" ? (this.isCurrency ? "p_commited" : "comm") : "q_commited";
      const unitPerc =
        pOrQ === "p"
          ? this.isCurrency
            ? "p_commited"
            : elementName + "Perc"
          : "q_commitedPerc";
      const label_txt =
        this.assetReference != "commodity"
          ? "Commited"
          : this.fixing_type === "basis"
          ? "Basis"
          : this.fixing_type === "ratio"
          ? "Ratio"
          : this.fixing_type === "price"
          ? "Ratio"
          : "Premium";
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["ratioBColor"](this.colorTheme),
        colorBdr: this.formatVars["ratioColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: elementName,
        elementNameTable: pOrQ === "p" ? "RATEC" : "PLANB",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: label_txt,
        nameData: elementName,
        sUnit: this.assetUnits["base"],
        unit: this.assetUnits["foreign"],
        unitPerc: unitPerc,
      });
    },
    market(pOrQ) {
      const elementName =
        pOrQ === "p" ? (this.isCurrency ? "p_market" : "market") : "";
      const unitPerc =
        pOrQ === "p"
          ? this.isCurrency
            ? "p_marketPerc"
            : elementName + "Perc"
          : "";
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
        colorBdr: "var(--whiteGray)",
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: elementName,
        elementNameTable: pOrQ === "p" ? "RATEE" : "",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Market",
        nameData: elementName,
        sUnit: this.assetUnits["base"],
        unit: this.assetUnits["foreign"],
        unitPerc: unitPerc,
      });
    },
    fixed(pOrQ) {
      const showFH = this.Analytics["userSelections"]["showFixedHedged"];
      const label = showFH ? "Fixed" : "Hedged";
      const priceElement = this.isCurrency
        ? showFH
          ? "p_fixed"
          : "p_fixedHedged"
        : showFH
        ? "fixed"
        : "fixedHedged";
      const qtyElement = showFH ? "q_fixed" : "q_fixedHedged";
      const elementName = pOrQ === "p" ? priceElement : qtyElement;

      const priceElementPerc = this.isCurrency
        ? showFH
          ? "p_fixedPerc"
          : "p_fixedHedgedPerc"
        : showFH
        ? "fixedPerc"
        : "fixedHedgedPerc";
      const qtyElementPerc = showFH ? "q_fixedPerc" : "q_fixedHedgedPerc";
      const elementNamePerc = pOrQ === "p" ? priceElementPerc : qtyElementPerc;
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["fixBColor"](this.colorTheme),
          colorBdr: this.formatVars["fixColor"],
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: elementName,
          elementNameTable: pOrQ === "p" ? "RATEH" : "PLANH",
          figureElements: "stackedBar1",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: label,
          nameData: elementName,
          sUnit: this.assetUnits["base"],
          unit: this.assetUnits["foreign"],
          unitPerc: elementNamePerc,
        }),
      };
    },
    options(pOrQ) {
      const elementName =
        pOrQ === "p" ? (this.isCurrency ? "p_hedged" : "hedge") : "q_hedged";
      const unitPerc =
        pOrQ === "p"
          ? this.isCurrency
            ? "p_hedgedPerc"
            : elementName + "Perc"
          : this.isCurrency
          ? "q_hedgedPerc"
          : elementName + "Perc";
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["hedgedBColor"](this.colorTheme),
          colorBdr: this.formatVars["hedgedColor"](this.colorTheme),
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: elementName,
          elementNameTable: pOrQ === "p" ? "RATEP" : "PLANOP",
          figureElements: "stackedBar2",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Options",
          nameData: elementName,
          sUnit: this.assetUnits["base"],
          unit: this.assetUnits["foreign"],
          unitPerc: unitPerc,
        }),
      };
    },
    programFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["programBColor"](this.colorTheme),
          colorBdr: this.formatVars["programColor"](this.colorTheme),
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "" : "q_program",
          elementNameTable: pOrQ === "p" ? "" : "PLANProg",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Program",
          nameData: pOrQ === "p" ? "" : "q_program",
          sUnit: this.assetUnits["base"],
          unit: this.assetUnits["foreign"],
          unitPerc: pOrQ === "p" ? "" : "q_programPerc",
        }),
      };
    },
    net(pOrQ) {
      const elementName =
        pOrQ === "p" ? (this.isCurrency ? "p_net" : "net") : "";
      const unitPerc =
        pOrQ === "p" ? (this.isCurrency ? "p_netPerc" : "netPerc") : "";
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["netBColor"](this.colorTheme),
        colorBdr: this.formatVars["netColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: elementName,
        elementNameTable: pOrQ === "p" ? "RATEN" : "",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Net",
        nameData: elementName,
        sUnit: this.assetUnits["base"],
        unit: this.assetUnits["foreign"],
        unitPerc: unitPerc,
      });
    },
    hedged() {
      return {
        ...this.getConfig({
          addLabel: true,
          label: "Options",
          colorBdr: "var(--net_2)",
          show: "showFixedFutures",
          typeFigure: { nameFigure: "twoStackedBars", toZero: true },
          figureDetails: null,
          xOffsetLeft: +2,
          showText: true,
          figureElements: "stacked2Bar",
          colorBckTable: "var(--net-alpha-2)",
        }),
        twoStackedBar: "q_hedged",
        customYFieldsText: [`q_fixed`, `q_hedged`],
      };
    },
    difference(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["differenceBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "v_netVsMkt" : "v_netVsMkt",
          elementNameTable: "diff",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Net - Mkt",
          nameData: pOrQ === "p" ? "v_netVsMkt" : "v_netVsMkt",
          sUnit: this.isCurrency
            ? this.assetUnits["base"]
            : this.assetUnits["foreign"],
          unit: this.assetUnits["foreign"],
          unitPerc: pOrQ === "p" ? "v_netVsMkt" : "difference",
        }),
      };
    },
    differenceOne(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["differenceBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "v_fixedHedged" : "differenceOne",
          elementNameTable: "diffOne",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Hedge P&L",
          nameData: pOrQ === "p" ? "v_fixedHedged" : "differenceOne",
          sUnit: this.isCurrency
            ? this.assetUnits["base"]
            : this.assetUnits["foreign"],
          unit: this.assetUnits["foreign"],
          unitPerc: pOrQ === "p" ? "v_fixedHedged" : "differenceOne",
        }),
      };
    },
    differenceTwo(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["differenceBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
          elementNameTable: "diffTwo",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Open Exposure",
          nameData: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
          sUnit: this.isCurrency
            ? this.assetUnits["base"]
            : this.assetUnits["foreign"],
          unit: this.assetUnits["foreign"],
          unitPerc: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
        }),
      };
    },
    differenceThree(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "v_budget" : "differenceThree",
          elementNameTable: "diffThree",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Net - Budget",
          nameData: pOrQ === "p" ? "v_budget" : "differenceThree",
          sUnit: this.isCurrency
            ? this.assetUnits["base"]
            : this.assetUnits["foreign"],
          unit: this.assetUnits["foreign"],
          unitPerc: pOrQ === "p" ? "v_budget" : "differenceThree",
        }),
      };
    },
    getConfig({
      addLabel,
      colorBckTable,
      colorBdr,
      divP,
      elementName,
      figureElements,
      format,
      isCurrency,
      isDetails,
      isPrices,
      label,
      nameData,
      sUnit,
      unit,
      elementNameTable,
      unitPerc = "",
    }) {
      return {
        addLabel,
        colorBckTable,
        colorBdr,
        divP,
        elementName,
        elementNameTable,
        figureElements,
        format,
        isCurrency,
        isDetails,
        isPrices,
        label,
        nameData,
        sUnit,
        unit,
        unitPerc,
      };
    },
  },
};
</script>

<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}

.container_chart_prices,
.container_chart_quantity {
  height: calc(100% - 22px);
}

.container-legends_chart_quantity,
.container-chart_chart_quantity {
  height: 100%;
}

.p-splitter {
  border: 0;
  background: 0;
  border-radius: 0;
  color: 0;
}

div.p-splitter .p-splitter-gutter {
  background: 0;
}

.container_table {
  height: 100%;
}
</style>
